import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './four_up_icons.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'
import Link from './basic/link'

function FourUpIcons(props) {
	const fields = props.fields
	const [items, setItems] = useState(fields.items.map(obj => ({ ...obj, buttonActive: false })))
	
	const handleMouseEvent = (index) => {
		setItems(
			items.map(
				(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, buttonActive: false }
			)
		)
	}

	return <BlockWrapper {...props} className={classNames(styles.four_up_icons, styles[fields.style])}>
		<ScrollAnimation styles={styles}>
				<div className={styles.icons_wrapper}>
					{items && items.map((item, i) => {
						return <div key={i} className={classNames(styles.item)} 
							onMouseEnter={() => handleMouseEvent(i)}
							onMouseLeave={() => handleMouseEvent()}
						>
							<Link href={item.button.button.url} target={item.button.target}>
								{item.icon.url && <Image className={styles.icon} {...item.icon} />}
								{item.button.button.url && 
									<Button className={styles.button} button_style='style_1' color={item.button.button_color} active={item.buttonActive}>{item.button.button.title}</Button>
								}
							</Link>
						</div>
					})}
				</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default FourUpIcons